





































import { Component, Vue } from "vue-property-decorator";
import ChartWrapper from "@/components/ChartWrapper.vue";
import { LatestBlocks, LatestTransactions } from "@/components/home";
import SelectionType from "@/components/SelectionType.vue";
import { ITransactionType } from "@/interfaces";

@Component({
  components: {
    ChartWrapper,
    LatestBlocks,
    LatestTransactions,
    SelectionType,
  },
})
export default class HomePage extends Vue {
  private dataView = "transactions";
  private transactionType: ITransactionType = { key: "ALL", type: -1 };

  get isChartEnabled() {
    return this.$store.getters["ui/priceChartOptions"].enabled;
  }

  public created() {
    const savedType = localStorage.getItem("transactionType");
    this.transactionType = savedType ? JSON.parse(savedType) : { key: "ALL", type: -1 };
  }

  private onTypeChange(type: ITransactionType) {
    this.transactionType = type;
  }
}
